import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { ConfirmDelete } from "./ConfirmDelete";
import {
  CardWrapper,
  ConnectionInfo,
  Heading,
  IconWrapper,
  ListWrapper,
  MainWrapper,
  StyledIcon,
  ToolLogo
} from "./ConnectedIntegrationLineWrapper.style";

type ConnectedIntegrationLineWrapperComponentProps = {
  image: string;
  name: string;
  accountName?: string;
  deleting: boolean;
  onDelete: () => void;
  children?: React.ReactNode;
  invertLogo?: boolean;
  noOpen?: boolean;
};

export function ConnectedIntegrationLineWrapper(
  props: ConnectedIntegrationLineWrapperComponentProps
) {
  const { onDelete, deleting, image, name, accountName, invertLogo, noOpen } = props;

  const [settingsVisible, toggleSettingsVisible] = useState(false);
  const [deleteConfirmModalVisible, toggleDeleteConfirmModalVisible] = useState(false);

  useEffect(() => {
    if (deleting === false) {
      toggleDeleteConfirmModalVisible(false);
    }
  }, [deleting]);

  const handleDeleteConfirmModalClose = useCallback(() => {
    toggleDeleteConfirmModalVisible(false);
  }, []);

  const handleDeleteIconClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    toggleDeleteConfirmModalVisible(true);
  }, []);

  const handleSettingsLineClick = useCallback(() => {
    toggleSettingsVisible(!settingsVisible);
  }, [settingsVisible]);

  return (
    <MainWrapper>
      <ConfirmDelete
        visible={deleteConfirmModalVisible}
        deleting={deleting}
        onClose={handleDeleteConfirmModalClose}
        onDelete={onDelete}
      />
      <ListWrapper onClick={handleSettingsLineClick} open={settingsVisible}>
        <CardWrapper>
          <ToolLogo logo={image} invert={invertLogo} />
          <Heading className="Heading">{name}</Heading>
        </CardWrapper>

        <ConnectionInfo>
          <span style={{ color: "#31B9B5" }}>
            <span>
              <FormattedMessage
                id="containers.Integrations.Implementations.Connected"
                defaultMessage="You are connected to: "
              />{" "}
            </span>
            {accountName}
          </span>
        </ConnectionInfo>

        <IconWrapper>
          {!noOpen && <StyledIcon icon={faPen} onClick={handleSettingsLineClick} title="Edit" />}

          <StyledIcon
            icon={faTrash}
            onClick={handleDeleteIconClick}
            deleteicn="true"
            title="Delete"
          />
        </IconWrapper>
      </ListWrapper>

      {settingsVisible && !noOpen && (
        <div
          style={{
            padding: "10px 40px"
          }}
        >
          {props.children}
        </div>
      )}
    </MainWrapper>
  );
}
